const constellationSpecs = {
    PlanetSkysat: {
      SatIds: [39418, 40072, 41601, 41771, 41772, 41773, 41774, 42987, 42988, 42989, 42990, 42991, 42992, 43797, 43802, 45788, 45789, 45790, 46179, 46180, 46235],
      resolution: 0.5,
      swath_width: [8, 8],
      spectral_range: "RGB, NIR",
    },
    PlanetFlock: {
      SatIds: [41610, 41613, 41618, 41956, 41968, 41990, 42048, 43119, 43120, 43122, 43769, 44080, 44088, 44090, 44094, 44095, 44096, 44098, 44808, 44809, 44811, 44812, 44814, 44816, 44818, 46285, 46286, 46288, 46289, 46290, 46291, 46296, 46297, 46313, 46314, 46321, 46527, 46528, 46529, 46597, 46609, 46612, 46735, 46737, 46738, 46812, 46813, 46814, 46815, 46816, 46817, 46819, 46820, 46821, 46822, 46825, 47452, 47456, 47462, 47469, 47471, 47472, 47473, 47474, 47475, 47477, 47478, 47479, 47490, 47491, 47492, 47494, 47495, 47496, 47498, 47499, 47500, 47514, 47515, 47516, 47518, 47520, 47521, 47522, 47523, 47527, 47528, 47530, 47539, 47540, 47542, 47543, 47544, 47545, 47612, 47617, 47684, 47685, 47686, 47687, 47688, 47698, 50992, 50994, 50996, 50997, 51000, 51003, 51004, 51005, 51006, 51007, 51009, 51010, 51011, 51012, 51015, 51016, 51017, 51018, 51020, 51023, 51024, 51026, 51027, 51028, 51029, 51035, 51037, 51039, 51040, 51041, 51042, 51043, 51045, 51046, 51047, 51048, 51049, 51052, 51056, 51064, 51065, 51066],
      resolution: 3,
      swath_width: [20, 20],
      spectral_range: "RGB, NIR",
    },
    BlackSkyGlobal: {
      SatIds: [43730, 49469, 49470, 49772, 49773, 49949, 49950, 52196, 52197, 43812, 44367, 44499, 46088, 46089, 47971],
      resolution: 1,
      swath_width: [6, 6],
      spectral_range: "RGB",
    },
    CapellaSar: {
      SatIds: [43791, 46269, 47481, 47489, 48605, 48913, 51071, 51072],
      resolution: 0.5,
      swath_width: [10, 10],
      spectral_range: "SAR",
    },
    GaoFen: {
      SatIds: [39150, 43259, 43260, 43262, 44622, 43585, 46396, 49492, 44819, 48079, 46610, 47231, 40118, 41727, 49495, 52200, 41194, 43461, 49122, 43484, 44703, 40701, 40894, 45625, 45794, 46025, 46232, 45856],
      resolution: 1,
      swath_width: [10, 10],
      spectral_range: "SAR",
    },
    IceEye: {
      SatIds: [43114, 43800, 44229, 44389, 44390, 46496, 46497, 47506, 47510, 48914, 48916, 48917, 48918, 51008, 51070, 52749, 52755, 52758, 52759, 52762],
      resolution: 3,
      swath_width: [30, 30],
      spectral_range: "SAR",
    },
    JilinGaoFen: {
      SatIds: [40958, 40959, 40960, 40961, 41914, 43022, 43023, 43024, 43159, 43160, 43943, 43946, 44314, 44777, 44836, 45016, 46454, 46455, 46456, 46457, 46458, 46459, 46460, 46461, 46462, 49256, 49338],
      resolution: 1,
      swath_width: [20, 20],
      spectral_range: "MS",
    },
    SatellogicNuSatAleph: {
      SatIds: [41557, 41558, 42760, 43195, 43204, 46272, 45017, 45018, 46827, 46828, 46829, 46830, 46831, 46832, 46833, 46840, 46835, 46836, 48905, 48921, 48920, 48919, 52168, 52178, 52171, 52184, 52172, 52747, 52764, 52748, 52752],
      resolution: 1,
      swath_width: [5, 5],
      spectral_range: "RGB, NIR",
    },
    GaoJingSuperView: {
      SatIds: [52320, 52322, 41907, 41908, 43099, 43100],
      resolution: 0.5,
      swath_width: [12, 12],
      spectral_range: "MS",
    },
    ISROCartoSat: {
      SatIds: [32783, 36795, 41599, 41948, 42767, 43111, 44804],
      resolution: 2.5,
      swath_width: [30, 30],
      spectral_range: "RGB",
    },
    GHGSat: {
      SatIds: [41602, 46278, 47509, 52737, 52744, 52746],
      resolution: 25,
      swath_width: [15, 15],
      spectral_range: "MS",
    },
    PleiadesNeo: {
      SatIds: [38012, 39019, 48268, 49070],
      resolution: 0.5,
      swath_width: [14, 14],
      spectral_range: "MS",
    },
    RapidEye: {
      SatIds: [33314, 33312, 33315, 33316, 33313],
      resolution: 6.5,
      swath_width: [77, 77],
      spectral_range: "RGB, NIR",
    },
    WorldView: {
      SatIds: [32060, 35946, 40115],
      resolution: 1,
      swath_width: [13, 13],
      spectral_range: "MS",
    },
    CosmoSkyMed: {
      SatIds: [44873, 51444, 31598, 32376, 33412, 37216],
      resolution: 3,
      swath_width: [40, 40],
      spectral_range: "SAR",
    },
    TianHui: {
      SatIds: [36985, 38256, 40988, 49049, 44207, 44209, 49071, 49072],
      resolution: 5,
      swath_width: [60, 60],
      spectral_range: "RGB, NIR",
    },
    Umbra: {
      SatIds: [50986, 52753],
      resolution: 0.25,
      swath_width: [4, 4],
      spectral_range: "SAR",
    },
    Stork: {
        SatIds: [51087, 51088, 51098, 48873, 48872],
        resolution: 5,
        swath_width: [10, 10],
        spectral_range: "RGB, NIR",
      },
      AxelSpaceGrus: {
        SatIds: [43890, 47934, 47933, 47936, 47935],
        resolution: 2.5,
        swath_width: [50, 50],
        spectral_range: "RGB, NIR",
      },
      CorvusLandMapper: {
        SatIds: [42846, 42847, 43118, 43767, 46931],
        resolution: 22,
        swath_width: [220, 220],
        spectral_range: "RGB, NIR",
      },
    };

export default constellationSpecs;
  